<template>
  <div class="add-product-category">
    <!-- 语言内容输入 -->
    <div class="language-section" v-if="languageList.length>0">
      <el-form label-width="80px" :model="formData">
        <el-form-item v-for="item in formData.languageList" :key="item.code" :label="item.name">
          <el-input v-model="item.value" :placeholder="`请输入${item.name}分类名称`" />
        </el-form-item>
      </el-form>
    </div>
    
    <!-- 表单操作 -->
    <div class="form-actions">
      <el-button @click="$emit('cancel')">取消</el-button>
      <el-button type="primary" @click="handleSubmit">保存</el-button>
    </div>
  </div>
</template>

<script>
import { addNewsCategory, updateNewsCategory } from "@/api/website"
import { getLanguage } from "@/api/public"
export default {
  name: 'AddNewsCategory',
  props: {
    newsCategory: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      formData: {
        languageList:[]
      },
      languageList:[],
    }
  },
  watch: {
    newsCategory: {
      handler(newCategory) {
        this.resetForm()
      },
      immediate: true
    }
  },
  mounted() {
    console.log("mounted")
    this.getLanguageList()
  },
  methods: {
    resetForm() {
      // 根据languageList初始化formData
      this.formData.languageList = []
      this.languageList.forEach(item => {
        this.formData.languageList.push({
          code: item.code,
          name: item.name,
          value: ''
        })
      })
    },
    async getLanguageList() {
      const res = await getLanguage()
      if(res.code === 200) {
        this.formData.languageList = []
        res.data.forEach(item => {
          this.formData.languageList.push({
            code: item.code,
            name: item.name,
            value: ''
          })
        })
        this.$forceUpdate()
        this.languageList = res.data
        console.log(this.formData)
      }
    },
    handleSubmit() {
      // 构建提交数据
      console.log(this.formData)
      let form = {'categories':{}};
      this.formData.languageList.forEach(item => {
        form['categories'][`${item.code}`] = item.value
      })
      form = JSON.stringify(form)
      if (this.newsCategory) {
        // 编辑模式
        // updateNewsCategory(this.newsCategory.id, submitData).then(res => {
        //   if(res.code === 200) {
        //     this.$emit('save', true)
        //   }
        // })
      } else {
        // 添加模式
        addNewsCategory(form).then(res => {
          if(res.code === 200) {
            this.$emit('save', true)
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.add-product-category {
  box-sizing: border-box;
  padding: 0 20px;
}

.language-section {
  box-sizing: border-box;
  margin-bottom: 30px;
  padding: 20px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background-color: #f9f9f9;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #f0f2f5;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .add-product-category {
    padding: 10px 0;
  }
  
  .form-actions {
    flex-direction: column;
  }
  
  .form-actions .el-button {
    width: 100%;
  }
}
</style>